import { Query } from '@/_core/cqrs/types/queries';
export class IsSubdomainAlreadyTakenQuery extends Query<boolean> {
    constructor(public Subdomain: string) {
        super('IsSubdomainAlreadyTakenQuery');
    }
}
